<template>
  <div v-if="carrier_type">
    <carrier-type-form v-model="carrier_type"></carrier-type-form>
  </div>
</template>
<script>
import Api from '@/store/jsonapi';

export default {
  data: function () {
    return {
      carrier_type: null
    };
  },
  mounted: function () {
    Api.find('carrier_types', this.carrier_type_id, {
      include: 'order_barcode_mail_template,export_document_email_template,barcode_customer_notification_mail_template'
    })
      .then(({ data }) => {
        this.carrier_type = data;
      })
      .catch(function () {
        console.error('Failed loading carrier type');
      });
  },
  props: ['carrier_type_id']
};
</script>
